import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import ProjectDetailAdmin from '../../sections/ProjectDetailAdmin'
import useApi from '../../../api/useApi';
import { ProjectGetDetail } from '../../../api/orgService';
import { toast } from 'react-toastify';


function ProjectAdminRead() {
    const location = useLocation()
    const [publishedData,setPublushedData] = useState({})
    // const [editState,setEditState] = useState(false)
    const { request: getProject, data:projectData, error:projectError,isLoading} = useApi(ProjectGetDetail);
  
    useEffect(()=>{
      if(location?.state){
        getProject(location?.state?.projectId)
      }else if(location?.state === null){
        // console.log(location?.pathname.split("/"))
        getProject(location?.pathname.split("/")[4])
      }
    },[location])
  
    useEffect(()=>{
      if (projectData?.status===200) {
        setPublushedData(projectData?.data);
      }
    },[projectData])
  
    useEffect(()=>{
        if(projectError){
            toast.error(`${JSON.stringify(projectError?.response?.data,null,2)}`,{position: "top-center"});
      }
    },[projectError])
  
    // console.log(publishedData)
  
  return (
    <div>
        <ProjectDetailAdmin projectData={publishedData}isLoading={isLoading} />
    </div>
  )
}

export default ProjectAdminRead